import React, {
  Fragment,
  useRef,
  useEffect,
  useState,
  useLayoutEffect,
} from "react";

import { useSelector, useDispatch } from "react-redux";
import loadable from "@loadable/component";
import { useTranslation } from "react-i18next";

import { appConfig } from "../../../appConfig";
import { AppService } from "../../../services/AppService";
import { addRequest, removeRequest } from "../../../redux/actions";
import Loader from "../../common/preloaders/Loader";

const Header = loadable(() => import("./sections/Header"), {
  fallback: Loader,
});
const OpenCauses = loadable(() => import("./sections/OpenCauses"), {
  fallback: Loader,
});
const PageSections = loadable(() => import("../pillar/ListSection"), {
  fallback: Loader,
});
const Blogs = loadable(() => import("../blog/ListSection"), {
  fallback: Loader,
});
const SupportPage = loadable(() => import("../SupportPage"), {
  fallback: Loader,
});

const scrollToRef = (ref, top) => {
  window.scrollTo({
    top,
    left: 0,
    behavior: "smooth",
  });
};

const Landing = (props) => {
  const { i18n } = useTranslation();

  const [isSupportPage, setIsSupportPage] = useState(false);
  const [path, setPath] = useState(props.pathname);
  const homeRef = useRef(null);
  const openCausesRef = useRef(null);
  const blogsRef = useRef(null);

  const pillars = useSelector((state) => state.main.pageContents.LANDING.PILLARS);
  const appSettings = useSelector((state) => state.main.settings);

  const executeScroll = (ref, top) => scrollToRef(ref, top);

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(addRequest("LOADING_LANDING_PAGE", "Loading Landing page..."));
  }, [dispatch]);

  useEffect(() => {
    const prepareOption = (page_data, is_support_page, ref_name) => {
      setTimeout(() => {
        if (is_support_page && typeof props.pathname != "undefined") {
          setPath(props.pathname.replace(`/${i18n.language}/`, ""));
        }
        setIsSupportPage(is_support_page);
      });

      setTimeout(() => {
        if (typeof ref_name != "undefined") {
          const top =
            !ref_name.current ||
            (ref_name.current &&
              ref_name.current.tagName &&
              ref_name.current.tagName === "HEADER")
              ? 0
              : ref_name && ref_name.current
              ? ref_name.current.offsetTop - 70
              : 120;
          executeScroll(ref_name, top);
        }
      });

      setTimeout(() => {
        document.title = page_data.title
          ? page_data.title
          : appConfig.appMainTitle;
        AppService.setMetaData({
          keywords: page_data.meta_keywords,
          description: page_data.meta_description,
        });

        dispatch(removeRequest("LOADING_LANDING_PAGE"));
      });
    };

    switch (props.pathname) {
      case `/${i18n.language}/open-causes`:
        prepareOption(
          {
            title: appSettings.static_page_open_causes_title
              ? appSettings.static_page_open_causes_title
              : appConfig.appMainTitle + " | Open Causes",
            meta_keywords: appSettings.static_page_open_causes_meta_keywords,
            meta_description:
              appSettings.static_page_open_causes_meta_description,
          },
          false,
          openCausesRef
        );
        break;
      case `/${i18n.language}/blog`:
        prepareOption(
          {
            title: appSettings.static_page_blog_title
              ? appSettings.static_page_blog_title
              : appConfig.appMainTitle + " | Our Blog",
            meta_keywords: appSettings.static_page_blog_meta_keywords,
            meta_description: appSettings.static_page_blog_meta_description,
          },
          false,
          blogsRef
        );
        break;
      case null:
      case undefined:
      case "undefined":
      case "":
      case `/${i18n.language}/`:
        prepareOption(
          {
            title: appSettings.static_page_home_title
              ? appSettings.static_page_home_title
              : appConfig.appMainTitle,
            meta_keywords: appSettings.static_page_home_meta_keywords,
            meta_description: appSettings.static_page_home_meta_description,
          },
          false,
          homeRef
        );
        break;
      default:
        if (typeof props.pathname == "undefined") {
          prepareOption(
            {
              title: appSettings.static_page_home_title
                ? appSettings.static_page_home_title
                : appConfig.appMainTitle,
              meta_keywords: appSettings.static_page_home_meta_keywords,
              meta_description: appSettings.static_page_home_meta_description,
            },
            false,
            homeRef
          );
        } else {
          prepareOption(
            {
              title: appSettings.static_page_home_title
                ? appSettings.static_page_home_title
                : appConfig.appMainTitle,
              meta_keywords: appSettings.static_page_home_meta_keywords,
              meta_description: appSettings.static_page_home_meta_description,
            },
            true
          );
        }

        break;
    }

    return () => {
      document.title = appConfig.appMainTitle;
      AppService.setMetaData();
    };
  }, [dispatch, path, props.pathname, appSettings, i18n.language]);

  return (
    <Fragment>
      {isSupportPage ? (
        <SupportPage pageCode={path} />
      ) : (
        <Fragment>
          <Header sectionRef={homeRef} />
          {pillars ? <PageSections pillars={pillars} /> : null}
          <OpenCauses sectionRef={openCausesRef} />
          <Blogs sectionRef={blogsRef} />
        </Fragment>
      )}
    </Fragment>
  );
};

export default Landing;
